import { inject, injectable } from 'tsyringe';
import { NoRecommendationsReasons } from '../no-recommendations-reasons.enums';
import { ConditionContext } from './interfaces/condition-context.interface';
import { ICondition, MatchResult } from './interfaces/condition.interface';
import { RecommendationConditions } from '../../datastore-service/models/conditions.model';
import {
  conditionType,
  ConditionType,
} from './decorators/condition-type.decorator';
import { LoggerService } from '../../logger.service';
import { kDITOWUtilsWrapper } from '../../../constants/injectionTokens';
import { IOWUtilsWrapper } from '../../../interfaces/ow-wrappers/ow-utils-wrapper.interface';

// -----------------------------------------------------------------------------
@injectable()
@conditionType(ConditionType.AppSpecific)
export class ConditionGPUSupported implements ICondition {
  private readonly logger = LoggerService.getCategory('ConditionGPUSupported');

  // ---------------------------------------------------------------------------
  public constructor(
    @inject(kDITOWUtilsWrapper)
    private readonly owUtilsWrapper: IOWUtilsWrapper,
  ) {}

  // ---------------------------------------------------------------------------
  // ICondition
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  public get id(): string {
    return this.logger.name;
  }

  // ---------------------------------------------------------------------------
  async match(): Promise<MatchResult> {
    const systemInformation = await this.owUtilsWrapper.getSystemInformation();
    if (!systemInformation || !systemInformation.VideoEncSupport) {
      return [false, NoRecommendationsReasons.GPUNotSupported];
    }

    const match = systemInformation.VideoEncSupport;
    this.logger.info(`GPU supported: ${match}`);

    const reason = match ? null : NoRecommendationsReasons.GPUNotSupported;
    return [match, reason];
  }

  // ---------------------------------------------------------------------------
  async shouldSkip(context: ConditionContext): Promise<boolean> {
    const { application } = context;
    if (!application.appConditions) {
      return true;
    }

    const hasCondition = application.appConditions.includes(
      RecommendationConditions.ConditionGPUSupported,
    );

    return !hasCondition;
  }
}
